/*
* Ferguson Finch custom JavaScript.
*
* Loaded on every page from the bottom of layout/theme.liquid. Keeping custom
* JavaScript here (not in theme.js) means it survives Palo Alto updates.
*
* Opens and closes the shared "Read more" text (snippets/read-more.liquid),
* used on collection, category landing and blog pages.
*/

(function() {
  function initReadMore() {
    document.querySelectorAll('[data-readmore]').forEach(function(block) {
      if (block.dataset.readmoreInit === 'true') return;
      block.dataset.readmoreInit = 'true';

      // Hide paragraphs that are empty apart from a space or line break
      block.querySelectorAll('p').forEach(function(p) {
        var html = p.innerHTML.replace(/&nbsp;|<br\s*\/?>/gi, '').trim();
        if (html === '') p.remove();
      });

      var btn = block.querySelector('[data-readmore-btn]');
      var content = block.querySelector('[data-readmore-content]');
      if (!btn || !content) return;

      btn.addEventListener('click', function() {
        var open = !block.classList.contains('is-open');

        // Gap above the opened text = the spacing between this text's paragraphs
        var spaced = block.querySelector('p:not(:last-child)');
        var gap = spaced ? getComputedStyle(spaced).marginBottom : '1em';
        content.style.marginTop = open ? gap : '0px';

        // Animate from the current height, then let it grow freely once open
        content.style.maxHeight = content.scrollHeight + 'px';
        if (!open) {
          content.offsetHeight; // apply the height before shrinking to 0
          content.style.maxHeight = '0px';
        }

        block.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      content.addEventListener('transitionend', function(event) {
        if (event.propertyName === 'max-height' && block.classList.contains('is-open')) {
          content.style.maxHeight = 'none';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReadMore);
  } else {
    initReadMore();
  }
  document.addEventListener('shopify:section:load', initReadMore);
})();